import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _MAP_FLAT_TYPE_TO_POL;
import * as React from 'react';
import { numberToPrettyString } from '@cian/utils';
import { FlatType } from '../../types/mvk_state';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DEFAULT_FLAT_POLYGON_FILL_STYLE = '#ffffff';
export var DEFAULT_MINIATURE_FLAT_POLYGON_FILL_STYLE = '#e4e4e4';
export var MAP_FLAT_TYPE_TO_POLYGON_COLOR = (_MAP_FLAT_TYPE_TO_POL = {}, _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.ROOM, '210, 136, 255'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.ONE_ROOM, '87, 200, 218'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.TWO_ROOM, '225, 210, 0'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.THREE_ROOM, '136, 227, 79'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.FOUR_ROOM, '232, 171, 127'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.FIVE_ROOM, '120, 122, 82'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.LARGE, '1, 92, 1'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.OPEN_PLAN, '0, 184, 0'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.SHARE, '221, 21, 125'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.STUDIO, '255, 153, 0'), _defineProperty(_MAP_FLAT_TYPE_TO_POL, FlatType.BED, '86, 102, 206'), _MAP_FLAT_TYPE_TO_POL);
export var POLYGON_COLOR_OPACITY = {
  DEFAULT: 0.3,
  HOVER: 0.8,
  MINIATURE: 0.4
};
export var DEFAULT_DRAW_SETTINGS = {
  DEFAULT_FILL_STYLE: '#f40212',
  POLYGONS_OPACITY: 0.3
};
export var DEFAULT_CANVAS_SIZE = {
  HEIGHT: 100,
  WIDTH: 100
};
export function polygonCoordsOperator(x, y, imageDrawParams) {
  var xScale = imageDrawParams && imageDrawParams.drawnImageWidth / imageDrawParams.imageContainerWidth || 1;
  var yScale = imageDrawParams && imageDrawParams.drawnImageHeight / imageDrawParams.imageContainerHeight || 1;
  var scale = Math.max(xScale, yScale);
  var paddingLeft = imageDrawParams && imageDrawParams.offsetLeft || 0;
  var paddingTop = imageDrawParams && imageDrawParams.offsetTop || 0;
  return [x / scale + paddingTop, y / scale + paddingLeft];
}
export function getColoredPolygons(floorPlanFlats, flats, coloredPolygonId, coloredFlatNumber) {
  var isMiniaturePolygons = coloredFlatNumber !== undefined;
  var coloredFlat = flats.find(function (flat) {
    return flat.flatNumber === coloredFlatNumber;
  });
  var defaultColor = isMiniaturePolygons ? DEFAULT_MINIATURE_FLAT_POLYGON_FILL_STYLE : DEFAULT_FLAT_POLYGON_FILL_STYLE;
  return floorPlanFlats.reduce(function (acc, planFlat) {
    if (!isFloorPlanFlatValid(planFlat)) {
      return acc;
    }
    var isColoredFlat = coloredFlat && coloredFlat.flatNumber === planFlat.flatNumber;
    var flat = flats.find(function (floorFlat) {
      return floorFlat.flatNumber === planFlat.flatNumber;
    });
    var fillColor = flat && (isMiniaturePolygons ? isColoredFlat : true) ? getPolygonColor(flat.roomCount, flat.id, isMiniaturePolygons, coloredPolygonId) : defaultColor;
    return acc.concat({
      id: flat ? flat.id : null,
      points: planFlat.polygon && planFlat.polygon.coordinates[0][0] || [],
      props: {
        fillColor: fillColor,
        fillOpacity: fillColor === DEFAULT_FLAT_POLYGON_FILL_STYLE ? POLYGON_COLOR_OPACITY.MINIATURE : undefined
      },
      tooltipContent: flat && /*#__PURE__*/_jsxs("div", {
        children: [flat.roomsTitle, " ", flat.area, " \u043C", /*#__PURE__*/_jsx("sup", {
          children: "2"
        }), /*#__PURE__*/_jsxs("div", {
          children: ["\u0437\u0430 ", numberToPrettyString(flat.price), " \u20BD "]
        })]
      })
    });
  }, []);
}
function getPolygonColor(flatType, polygonId, isMiniaturePolygons, coloredPolygonId) {
  var flatTypeColor = MAP_FLAT_TYPE_TO_POLYGON_COLOR[flatType];
  if (isMiniaturePolygons) {
    return flatTypeColor ? "rgb(".concat(flatTypeColor, ")") : DEFAULT_MINIATURE_FLAT_POLYGON_FILL_STYLE;
  }
  var flatTypeColorOpacity = polygonId === coloredPolygonId ? POLYGON_COLOR_OPACITY.HOVER : POLYGON_COLOR_OPACITY.DEFAULT;
  return flatTypeColor ? "rgba(".concat(flatTypeColor, ", ").concat(flatTypeColorOpacity, ")") : DEFAULT_FLAT_POLYGON_FILL_STYLE;
}
export function isFloorPlanFlatValid(floorPlanFlat) {
  return Boolean(floorPlanFlat.id && floorPlanFlat.flatNumber && floorPlanFlat.polygon && Array.isArray(floorPlanFlat.polygon.coordinates[0][0]));
}
export function pnpoly(nvert, vertx, verty, testx, testy) {
  var i;
  var j;
  var c = 0;
  for (i = 0, j = nvert - 1; i < nvert; j = i++) {
    if (verty[i] > testy !== verty[j] > testy && testx < (vertx[j] - vertx[i]) * (testy - verty[i]) / (verty[j] - verty[i]) + vertx[i]) {
      c = Number(!c);
    }
  }
  return c;
}